import { FiHome, FiGrid, FiBook, FiUsers, FiBarChart2, FiLogOut, FiList, FiUser, FiTrendingUp } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import logo from '../../../../assets/logo.png';
import { Computer } from "lucide-react";

const Sidebar = ({ isCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: <FiHome />,
      link: "/marketplace/independent_researcher/dashboard",
    },
    {
      id: "categories",
      label: "Publications",
      icon: <FiGrid />,
      link: "/marketplace/independent_researcher/dashboard/publications",
    },
    {
      id: "categories1",
      label: "Opportunity Hub",
      icon: <FiTrendingUp />,
      link: "/marketplace/independent_researcher/dashboard/opportunity_hub",
    },
    {
      id: "categories2",
      label: "My Lab Spaces",
      icon: <Computer />,
      link: "/marketplace/independent_researcher/dashboard/mylabspaces",
    },
    {
      id: "users",
      label: "Theoretical Idea",
      icon: <FiList />,
      link: "/marketplace/independent_researcher/dashboard/publications/add_theoretical_idea",
    },
    {
      id: "members",
      label: "Prototype",
      icon: <FiUsers />,
      link: "/marketplace/independent_researcher/dashboard/publications/add_prototype",
    },
    {
      id: "books",
      label: "Lab Experiment",
      icon: <FiBook />,
      link: "/marketplace/independent_researcher/dashboard/publications/add_lab_experiment",
    },
    {
      id: "reports",
      label: "Industrial Application",
      icon: <FiBarChart2 />,
      link: "/marketplace/independent_researcher/dashboard/publications/add_industrial_application",
    },
    {
      id: "settings",
      label: "Profile",
      icon: <FiUser />,
      link: "/marketplace/independent_researcher/dashboard/profile",
    },
  ];

  const logout = () => {
    localStorage.removeItem("access_token");
    navigate("/");
  };

  return (
    <div
      className={`bg-white border-r border-gray-200 h-screen fixed z-50 flex flex-col transition-all duration-300 ${
        isCollapsed ? "w-20" : "w-72"
      }`}
    >
      {/* Header */}
      <div className={`p-[28px] border-b border-gray-100 flex items-center ${isCollapsed ? 'py-[38px] justify-center' : 'justify-start'}`}>
        <div className="flex items-center gap-3">
          <img
            src={logo}
            alt="axionnest"
            className="w-full max-w-[150px] object-contain cursor-pointer"
            onClick={() => navigate('/marketplace/independent_researcher/')}
          />
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 p-4 overflow-y-auto scrollbar-hidden">
        <ul className="space-y-1">
       {menuItems.map((item) => {
  const isActive =
    item.link === "/marketplace/independent_researcher/dashboard"
      ? location.pathname === item.link
      : location.pathname === item.link ||
        location.pathname.startsWith(item.link + "/");

  return (
    <li key={item.id}>
      <button
        onClick={() => navigate(item.link)}
        className={`w-full flex items-center p-3 rounded-xl transition-all duration-200 ${
          isActive
            ? "bg-[#e8f0f7] text-[#0f6abf]"
            : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
        }`}
      >
        <div
          className={`w-8 h-8 rounded-lg flex items-center justify-center ${
            isActive
              ? "bg-white text-[#0f6abf]"
              : "bg-gray-100 text-gray-600"
          }`}
        >
          <span className="text-lg">{item.icon}</span>
        </div>

        {!isCollapsed && (
          <span className="ml-3 font-medium text-sm">
            {item.label}
          </span>
        )}
      </button>
    </li>
  );
})}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-100">
        <button
          onClick={logout}
          className={`w-full flex items-center p-3 text-gray-600 rounded-xl hover:bg-gray-50 hover:text-gray-900 transition-all duration-200 ${
            isCollapsed ? 'justify-center' : ''
          }`}
        >
          <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
            <FiLogOut className="text-lg text-gray-600" />
          </div>
          {!isCollapsed && (
            <span className="ml-3 font-medium text-sm">Logout</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;